module.exports = __webpack_public_path__ + "static/Desktops_Dell_Precision_Timeline-f3ddf55c2e9d9c7b7ec80a8b39dbd2d3.png";